import { initAnalytics } from "./utils/sensors.js";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "./assets/main.css";
import "./assets/scss/main.scss";
import getI18n from "./i18n/index.js";
import "./utils/flexible.js";
import Bridge from "./utils/jsBridge.js";
import debounce from "./utils/debounce.js";
import { Locale } from "vant";
import enUS from "vant/es/locale/lang/en-US";
import { ClientInfo, getClientInfo, getCommonInfo } from "@voghion/native-api";
import "./utils/webp.js";
import { mockClientInfo } from "./utils/dev.js";
import { Dialog } from "vant";
import "vant/es/toast/style";
import "vant/es/dialog/style";
import { useSetting } from "./composables/use-setting.js";
import { checkUpgrade } from "@/utils/upgrade";
import { createPinia } from "pinia";
import { useEnvStore } from "@/states/env";
import { isEnvProd } from "@/utils/env";
import logEventPlugin from "@/plugins/log-event";
import "virtual:uno.css";
import { useUserStore } from "./states/user.js";
import { cacheApp } from "./utils/app.js";
import "emoji-picker-element";
import { dispatchWindowEvent } from "@voghion/fe-util";

function initApp() {
  const app = createApp(App);
  const pinia = createPinia();

  app.use(pinia);
  app.provide("$bridge", Bridge);
  app.use(router);
  app.use(debounce);
  app.use(Dialog);
  app.use(ElementPlus);
  const { getClientInfo } = useSetting();

  const clientInfo = getClientInfo();
  const defaultLocale = clientInfo?.language || "en";
  const i18n = getI18n(defaultLocale);
  app.use(i18n);
  app.use(logEventPlugin);
  document.title = i18n.global.t("message.title");
  Locale.use("en-US", enUS);
  app.mount("#app");
  cacheApp(app);
  router.afterEach(() => {
    // 在页面加载成功后，隐藏全局的资源错误监控和loading
    if (!window.appReady) {
      dispatchWindowEvent("appReady");
    }
  });
}

checkUpgrade();

Promise.all([getClientInfo(), getCommonInfo()]).then((res) => {
  const settingComposer = useSetting();
  const clientInfoRes = res[0];

  // 地址栏传token，测试用
  let searchToken: string | null = "";
  const search = window.location.href.split("#/");
  if (search[1]) {
    const searchObj = new URLSearchParams(search[1]);

    if (searchObj.get("testToken")) {
      searchToken = searchObj.get("testToken");
    }
  }

  mockClientInfo(clientInfoRes, searchToken);
  let clientInfo: ClientInfo | null = null;
  let deviceCode = "";
  if (clientInfoRes.data) {
    clientInfo = clientInfoRes.data;
    settingComposer.updateClientInfo(clientInfo);
    deviceCode = clientInfo.deviceCode;
  }

  initApp();
  /**
   * store 的更新必须要放在初始化之后
   */
  const userStore = useUserStore();
  if (clientInfo) {
    userStore.updateClientInfo(clientInfo);
  }
  let userId: string = "";
  const commonInfoRes = res[1];
  if (commonInfoRes.data) {
    const envStore = useEnvStore();
    const commonInfo = commonInfoRes.data;
    userId = commonInfo.userId || "";
    envStore.statusBarHeight = commonInfo.statusBarHeight || 0;
    envStore.inAppTab = commonInfo.inAppTab || false;
    if (commonInfo.inAppTab) {
      /**
       * 如果是常驻页面，开启监听用户退出和登录
       */
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          getClientInfo().then((res) => {
            if (res.data) {
              userStore.updateClientInfo(res.data);
            }
          });
          checkUpgrade().then((needRefresh) => {
            needRefresh && window.location.reload();
          });
        }
      });
    }
  }
  initAnalytics({
    isProd: isEnvProd(),
    userId,
    deviceCode,
    router,
  });
});
